<div class="mr-xsmall-b">
  <h4 *ngIf="phraseGroup.title">{{ phraseGroup.title }}</h4>
  <dl class="phrases-list">
    <div *ngFor="let phrase of phraseGroup.phrases" class="cf">
      <dt [innerHTML]="phrase.site | finSafe: 'html'"></dt>
      <dd [innerHTML]="phrase.local | finSafe: 'html'"></dd>
    </div>
  </dl>
</div>
